<!-- <div class="homeBanner w-100">
  <div class="content">
    <div class="contentCenter">
      <h1>Institute for Training in Ministry (iTIM)</h1>
      <p>
        The INSTITUTE for TRAINING in MINISTRY can help your church “prepare
        God’s people for works of service, and so build up the body of Christ
        (Ephesians 4:12)
      </p>
    </div>
  </div>
  <img src="./assets/images/homeBanner.jpg" class="w-100" />
</div> -->

<div
  id="carouselExampleControls"
  class="carousel slide"
  data-ride="carousel"
  data-interval="4000"
  data-pause="false"
  style="margin-top: 85px"
  data-wrap="false"
>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img
        class="d-block w-100"
        src="../../../assets/images/homeBanner1.jpg"
        alt="First slide"
      />
      <div class="carousel-caption d-md-block">
        <p class="txt-wht">
          iTIM can help you "prepare God's people for the work of ministry, and
          so build up the body of Christ". (Ephesians 4:12)
        </p>
      </div>
    </div>
    <div class="carousel-item">
      <img
        class="d-block w-100"
        src="../../../assets/images/homeBanner3.jpg"
        alt="Second slide"
      />
      <div class="carousel-caption d-md-block">
        <p class="txt-wht">
          iTIM can help you "prepare God's people for the work of ministry, and
          so build up the body of Christ". (Ephesians 4:12)
        </p>
      </div>
    </div>
    <div class="carousel-item">
      <img
        class="d-block w-100"
        src="../../../assets/images/homeBanner2.jpg"
        alt="Third slide"
      />
      <div class="carousel-caption d-md-block">
        <p class="txt-wht">
          iTIM can help you "prepare God's people for the work of ministry, and
          so build up the body of Christ". (Ephesians 4:12)
        </p>
      </div>
    </div>
    <div class="carousel-item">
      <img
        class="d-block w-100"
        src="../../../assets/images/homeBanner4.jpg"
        alt="Fourth slide"
      />
      <div class="carousel-caption d-md-block">
        <p class="txt-wht">
          iTIM can help you "prepare God's people for the work of ministry, and
          so build up the body of Christ". (Ephesians 4:12)
        </p>
      </div>
    </div>
  </div>
  <a
    class="carousel-control-prev"
    href="#carouselExampleControls"
    role="button"
    data-slide="prev"
  >
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>

  <a
    class="carousel-control-next"
    href="#carouselExampleControls"
    role="button"
    data-slide="next"
  >
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
</div>

<div class="mainContnet">
  <div class="container">
    <p>
      iTIM consists of 18 courses, workbook in format, on 5 ministry tracks:
      Discipleship, Church Ministries, Church Leadership, Bible Teaching, and
      Pastoral Ministry. Each course features solid biblical content, personal
      applications, and a practicum wherein learners put into practice what they
      have learned in that course.
    </p>

    <p>
      iTIM features a <b><em>“head”</em></b
      >, <b><em>“heart”</em></b
      >, and <b><em>“hands”</em></b> approach to learning. This means that all
      iTIM courses include:
    </p>
    <ul class="list">
      <li>vital content</li>
      <li>life applications</li>
      <li>ministry involvement</li>
    </ul>
    <p>
      Please enroll in the free iTIM seminar to learn more about iTIM courses
      and how to effectively use them. This 2-hour seminar can be completed in
      stages, as your work will be saved. After completing the seminar, you can
      take all of these courses online without cost, either individually, or as
      a group.
    </p>
  </div>
  <div class="container mt-lg-5 mb-lg-5 cardButton">
    <div class="row">
      <div class="col-md-4 cardHover">
        <div class="card p-3 mb-2 card1">
          <div class="d-flex justify-content-between">
            <div class="d-flex flex-row align-items-center">
              <div class="ms-2 c-details">
                <ul>
                  <li class="dropdown" style="cursor: pointer; height: 40px">
                    <a
                      class="dropdown-toggle main-btn"
                      data-bs-toggle="dropdown"
                      >iTIM Course Tracks
                      <i class="fas fa-chevron-down"></i>
                    </a>
                    <ul class="dropdown-menu">
                      <li *ngFor="let data of languageData">
                        <ng-container
                          *ngIf="
                            data.language === 'Chinese';
                            else otherLanguages
                          "
                        >
                          <a
                            href="https://itim-online.org/"
                            target="_blank"
                            class="dropdown-item"
                          >
                            Chinese <i class="fas fa-chevron-right"></i>
                          </a>
                        </ng-container>
                        <ng-template #otherLanguages>
                          <a class="dropdown-item">
                            {{ data.language }}
                            <i class="fas fa-chevron-right"></i>
                          </a>
                        </ng-template>
                        <ul class="submenu dropdown-menu">
                          <li *ngFor="let innerData of data.tracks">
                            <a
                              (click)="
                                route(
                                  innerData.trackName,
                                  innerData.trackId,
                                  data.languageid
                                )
                              "
                              class="dropdown-item"
                            >
                              {{ innerData.trackName }}
                            </a>
                          </li>
                          <li></li>
                        </ul>
                      </li>

                      <!-- <li *ngFor="let data of languageData">
                        <a class="dropdown-item"
                          >{{ data.language }}
                          <i class="fas fa-chevron-right"></i>
                        </a>
                        <ul class="submenu dropdown-menu">
                          <li *ngFor="let innerData of data.tracks">
                            <a
                              (click)="
                                route(
                                  innerData.trackName,
                                  innerData.trackId,
                                  data.languageid
                                )
                              "
                              class="dropdown-item"
                              >{{ innerData.trackName }}</a
                            >
                          </li>
                          <li></li>
                        </ul>
                      </li> -->
                      <!-- <li>
                        <a href="https://itim-online.org/" target="_blank" class="dropdown-item"
                          >Chinese
                        </a>
                      </li> -->
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 cardHover">
        <div class="card p-3 mb-2 card1">
          <div class="d-flex justify-content-between">
            <div class="d-flex flex-row align-items-center">
              <div class="ms-2 c-details">
                <ul>
                  <li style="cursor: pointer; height: 40px">
                    <a [routerLink]="['/training-seminar-introductory']">
                      <h6 class="mb-0">Enroll in the free iTIM Seminar</h6>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 cardHover">
        <div class="card p-3 mb-2 card1">
          <div class="d-flex justify-content-between">
            <div class="d-flex flex-row align-items-center">
              <div class="ms-2 c-details">
                <a [routerLink]="['/skill-skeptical']">
                  <h6 class="mb-0">
                    Skeptical? Watch the first video of the iTIM seminar
                  </h6>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-static-footer class="footer"></app-static-footer>
</div>
